export const ItemListingPageTypes = {
    MY_REQUESTS : 'My_Requests',
    ASSIGNED_TO_ME: 'Assigned_To_Me',
    ME: 'Me',
    ALL: 'All',
    VIEW_ONLY: 'View_Only'
};


// WEBPACK FOOTER //
// ./src/constants/index.js